import { createContext, useContext } from 'react';

export type Appearance = 'light' | 'dark' | 'system';

export interface ThemeContextValue {
    appearance: Appearance;
    setAppearance: (value: Appearance) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useAppearance(): ThemeContextValue {
    const ctx = useContext(ThemeContext);
    if (!ctx) {
        throw new Error('useAppearance must be used within <ThemeProvider>');
    }
    return ctx;
}
